export default class fun {

  /**
   * トップへ戻る
   */
  static ClickGoTop() {
    const duration = 300;
    let begin = new Date() - 0;
    let yOffset = window.pageYOffset;
    let timer = setInterval(() => {
      let current = new Date() - begin;
      if (current > duration) {
        clearInterval(timer);
        current = duration;
      }
      window.scrollTo(0, yOffset * (1 - current / duration));
    }, 10);
  }

  /**
   * トグル
   */
  static ClickToggle($this) {
    $this.classList.toggle("js-open");
  }

  /**
   * トグル
   */
  static ClickDetails($this) {
    if ($this.open) {
      alert('aaa');
    } else {
      alert('bbb');
    }
  }

  /**
   * ハンバーガーメニュー（開く）
   */
  static MenuOpen($this) {
    const navView = document.getElementById("menu_area");
    if ($this.getAttribute("aria-expanded") == "false") {
      document.documentElement.classList.add("js-scroll_fixed");
      $this.setAttribute("aria-expanded", "true");
      navView.setAttribute("aria-hidden", "false");
      $this.classList.add("js-open");
      $this.classList.remove("js-close");
      navView.classList.add("js-open");
      navView.classList.remove("js-close");
    }
  }

  /**
   * ハンバーガーメニュー（閉じる）
   */
  static MenuClose($this) {
    const navView = document.getElementById("menu_area");
    document.documentElement.classList.remove("js-scroll_fixed");
    $this.setAttribute("aria-expanded", "false");
    navView.setAttribute("aria-hidden", "true");
    $this.classList.remove("js-open");
    $this.classList.add("js-close");
    navView.classList.remove("js-open");
    navView.classList.add("js-close");
  }

  /**
   * タブ
   */
  static ClickTab($this) {
    const parent = $this.parentNode;
    const el = parent.children;
    const el_data = parent.dataset.tab;
    for (let i = 0; i < el.length; i++) {
      el[i].classList.remove("js-open");
    }
    $this.classList.add("js-open");
    for (let i = 0; i < el.length; i++) {
      if (el[i].classList.contains("js-open")) {
        var index = i;
      }
    }
    const tab_contents = document.querySelectorAll("[data-tab_contents]");
    for (let i = 0, len = tab_contents.length; i < len; ++i) {
      const tab_data = tab_contents[i].dataset.tab_contents;
      if (el_data == tab_data) {
        let tab_child = tab_contents[i].children;
        for (var ii = 0; ii < tab_child.length; ii++) {
          tab_child[ii].classList.remove("js-open");
        }
        tab_child[index].classList.add("js-open");
      }
    }
  }

  /**
   * モーダル（開く）
   */
  static ClickModalOpen($this) {
    $this.classList.toggle("js-open");
    const this_data = $this.dataset.modal;
    const modal_background = document.querySelector('[data-modal_background="' + this_data + '"]');
    const modal_contents = document.querySelector('[data-modal_contents="' + this_data + '"]');
    const modal_contents_text_add = document.querySelector('[data-modal_contents_text_add="' + this_data + '"]');
    const modal_contents_text = document.querySelector('[data-modal_contents_text="' + this_data + '"]');
    if ($this.classList.contains("js-open")) {
      modal_background.classList.add("js-open");
      modal_contents.classList.add("js-open");
      document.documentElement.classList.add("js-scroll_fixed");
      modal_contents_text.innerHTML = '';
      modal_contents_text.insertAdjacentHTML('afterbegin', modal_contents_text_add.innerHTML);
      $this.setAttribute("aria-expanded", "true");
      modal_contents.setAttribute("aria-hidden", "false");
    } else {
      modal_contents.classList.remove("js-open");
    }
  }

  /**
   * モーダル（閉じる）
   */
  static ClickModalClose($this) {
    const this_data = $this.dataset.modal_close;
    const modal = document.querySelector('[data-modal="' + this_data + '"]');
    const modal_background = document.querySelector('[data-modal_background="' + this_data + '"]');
    const modal_contents = document.querySelector('[data-modal_contents="' + this_data + '"]');
    const modal_contents_text = document.querySelector('[data-modal_contents_text="' + this_data + '"]');
    modal.classList.remove("js-open");
    modal_background.classList.remove("js-open");
    modal_contents.classList.remove("js-open");
    document.documentElement.classList.remove("js-scroll_fixed");
    modal.setAttribute("aria-expanded", "false");
    modal_contents.setAttribute("aria-hidden", "true");
    modal_contents_text.innerHTML = '';
  }

  /**
   * 別ページのスムーズスクロール
   */
  static SmoothLink() {
    const urlHash = location.hash;
    if (urlHash) {
      // スクロール位置に持たせる高さ
      let headH = document.getElementById('header-bar').clientHeight;
      // 最低必要な高さ
      const minH = 80;
      if (headH < minH || headH === undefined) {
        headH = minH;
      } else {
        headH = headH + 20;
      }
      window.scrollTo(0, 0);
      const interval = 10;
      const divisor = 8;
      const range = divisor / 2 + 1;
      let toY;
      let nowY = window.pageYOffset;
      const target = document.querySelector(urlHash);
      const targetRect = target.getBoundingClientRect();
      const targetY = targetRect.top + nowY - headH;
      setTimeout(function doScroll() {
        toY = nowY + Math.round((targetY - nowY) / divisor);
        window.scrollTo(0, toY);
        nowY = toY;
        if (document.body.clientHeight - window.innerHeight < toY) {
          window.scrollTo(0, document.body.clientHeight);
          return;
        }
        if (toY >= targetY + range || toY <= targetY - range) {
          window.setTimeout(doScroll, interval);
        } else {
          window.scrollTo(0, targetY);
        }
      }, 200);
    }
  }

  /**
   * 同ページのスムーズスクロール
   */
  static SmoothLinkSame(hash) {
    // スクロール位置に持たせる高さ
    let headH = document.getElementById('header-bar').clientHeight;
    // 最低必要な高さ
    const minH = 80;
    if (headH < minH || headH === undefined) {
      headH = minH;
    } else {
      headH = headH + 20;
    }
    const interval = 10;
    const divisor = 8;
    const range = divisor / 2 + 1;
    let toY;
    let nowY = window.pageYOffset;
    const target_hash = document.querySelector(hash);
    const targetRect = target_hash.getBoundingClientRect();
    const targetY = targetRect.top + nowY - headH;
    setTimeout(function doScroll() {
      toY = nowY + Math.round((targetY - nowY) / divisor);
      window.scrollTo(0, toY);
      nowY = toY;
      if (document.body.clientHeight - window.innerHeight < toY) {
        window.scrollTo(0, document.body.clientHeight);
        return;
      }
      if (toY >= targetY + range || toY <= targetY - range) {
        window.setTimeout(doScroll, interval);
      } else {
        window.scrollTo(0, targetY);
      }
    }, 200);
  }

  /**
   * 外部ページは_blankを挿入
   */
  static TargetBlank() {
    const website = window.location.hostname;
    const internalLinkRegex = new RegExp('^((((http:\\/\\/|https:\\/\\/)(www\\.)?)?'
      + website
      + ')|(localhost:\\d{4})|(\\/.*))(\\/.*)?$', '');
    const anchorEls = document.querySelectorAll('a');
    const anchorElsLength = anchorEls.length;

    for (let i = 0; i < anchorElsLength; i++) {
      let anchorEl = anchorEls[i];
      let href = anchorEl.getAttribute('href');
      if (!internalLinkRegex.test(href)) {
        anchorEl.setAttribute('target', '_blank');
        anchorEl.setAttribute('rel', 'noopener noreferrer');
      }
    }
  }
}
